import { LandingPageQuery } from 'queries/resources'
import { NewsCardsAllQuery } from 'queries/news'
import { GQLClient } from 'services/graphql'
import { Flatten, PickFirst, Slugify } from 'services/utils'
import LandingPagesContents from 'templates/LandingPagesContents/LandingPagesContents'
import { GetCachedData, GetMetaData } from 'services/data.service'
import { batchSquidexRequests } from 'services/squidex'

const NewsLanding = ({
  pageData,
  type,
  topNav,
  mainNav,
  meta,
  pathData,
  featured = [],
  resources = [],
  topics = [],
  authors = [],
  footerContent = {},
  applicationSettings = {}
}) => {
  const { headline, subheadline, footerCTA = [] } = pageData || {}

  return (
    <LandingPagesContents
      headline={headline}
      subheadline={subheadline}
      featured={featured}
      supportingContent={pageData.supportingContent}
      resources={{ resource: resources }}
      topics={topics}
      authors={authors}
      meta={meta}
      topNav={topNav}
      mainNav={mainNav}
      footerCTA={footerCTA}
      footerContent={footerContent}
      applicationSettings={applicationSettings}
      hasFilters={false}
      isNews={true}
    />
  )
}
export default NewsLanding

export async function getStaticProps(context) {
  const client = await GQLClient()
  const data = await client.request(LandingPageQuery('news'))
  const resources = await batchSquidexRequests( NewsCardsAllQuery, 'queryNewsContents' );
  const content = Flatten(PickFirst(data.queryLandingPagesContents))
  const allResources = resources
    .map((resource) => Flatten(resource))
    .sort((a, b) => {
      return new Date(b.createdAt) - new Date(a.createdAt)
    })
  //const featured = allResources.filter((resource) => resource.featured === true).slice(0, 6)
  let pageData = {
    type: '',
    pageData: content,
    meta: GetMetaData(content.pageBase),
    pathData: require('data/paths.json'),
    resources: allResources,
    featured: [],
    authors: []
  }
  pageData = GetCachedData(pageData)
  return {
    props: pageData || {}
  }
}
